<template>
  <div class="bg-white h-[75px] min-h-[75px] w-[90%] flex flex-row items-center justify-between rounded-[50px] px-3 relative z-50">
    <div class="flex items-center justify-start h-full w-1/2">
      <a 
        href="https://courdescomptes.bj"
        class="cursor-pointer block"
      >
        <Image v-bind="currentLogoProps" />
      </a>
    </div>
    
    <div class="flex items-center justify-end h-full w-1/2">
      <HamburgerBtn 
        @click="handleToggle"
        :is-open="isMenuOpen" 
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Image from '@/components/atoms/image/Image.vue'
import HamburgerBtn from '@/components/atoms/button/HamburgerBtn.vue'
import { MOBILE_LOGO_PROPS } from '../constants/mobileNavigation'

interface Props {
  logoProps?: any
  isMenuOpen: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  menuToggle: []
}>()

const currentLogoProps = computed(() => props.logoProps || MOBILE_LOGO_PROPS)

const handleToggle = () => {
  emit('menuToggle')
}
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

